"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ROICalculatorSlider_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorSlider");
var ROICalculatorWidget_1 = require("./ROICalculatorWidget");
var ROITextInput_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROITextInput");
var ROIStep_1 = require("./ROISteps/ROIStep");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var classnames_1 = __importDefault(require("classnames"));
var ROISlider = (function (_super) {
    __extends(ROISlider, _super);
    function ROISlider() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.debouncedTrackInteraction = (0, lodash_1.debounce)(_this.props.trackSliderInteraction, 500);
        _this.handleValueChange = function (value) {
            _this.props.onChangeValue(value);
            _this.debouncedTrackInteraction();
        };
        _this.handleChangeOption = function (optionName, optionValue) {
            var nextValue = !!optionValue ? parseFloat(optionValue) : 0;
            _this.props.onChangeOption(optionName, nextValue);
        };
        _this.handleHighlightColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var roiCalculator = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("roiCalculator"));
            roiCalculator.highlightColor = {
                themeIndex: color.themeIndex,
                abs: color.value,
            };
            blockStyleStore.setElementStyle("roiCalculator", roiCalculator);
        };
        _this.handleEditOption = function (optionName, optionValue) {
            _this.props.onEditOption(ROICalculatorWidget_1.ROIElement.Slider, optionName, optionValue);
        };
        _this.renderInputOptions = function () {
            var _a = _this.props, label = _a.label, min = _a.min, max = _a.max, increment = _a.increment, initialValue = _a.initialValue;
            return (react_1.default.createElement("div", { className: "roi-calculator-options__inner" },
                react_1.default.createElement("div", { className: "roi-calculator-options__heading" }, "Slider Options"),
                react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Label", value: label, inputName: "label", onChange: _this.props.onChangeOption, maxLength: 200, onValueEdited: _this.handleEditOption }),
                react_1.default.createElement("div", { className: "roi-calculator-options__dual" },
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Min", value: "".concat(min), onChange: _this.handleChangeOption, type: kaleidoscope_1.TextInputType.Number, inputName: "min", onValueEdited: _this.handleEditOption, error: _this.minErrorMessage }),
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Max", value: "".concat(max), onChange: _this.handleChangeOption, type: kaleidoscope_1.TextInputType.Number, inputName: "max", onValueEdited: _this.handleEditOption, error: _this.maxErrorMessage })),
                react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Initial value", value: "".concat(initialValue), onChange: _this.handleChangeOption, type: kaleidoscope_1.TextInputType.Number, inputName: "initialValue", onValueEdited: _this.handleEditOption, error: _this.initialValueErrorMessage }),
                react_1.default.createElement(ROITextInput_1.ROITextInput, { label: "Increment", value: "".concat(increment), onChange: _this.handleChangeOption, type: kaleidoscope_1.TextInputType.Number, inputName: "increment", onValueEdited: _this.handleEditOption, error: _this.incrementErrorMessage }),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Highlight color"),
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(ColorPalette_1.default, { presetColors: _this.props.brandStore.colorsWithThemeIndex, onColorChange: _this.handleHighlightColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(_this.highlightColor), _this.props.brandStore.colorsWithThemeIndex), theme: "light", type: "content" })))));
        };
        return _this;
    }
    ROISlider.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.debouncedTrackInteraction) === null || _a === void 0 ? void 0 : _a.cancel();
    };
    ROISlider.prototype.render = function () {
        var _a = this.props, roiStepsOrchestrator = _a.roiStepsOrchestrator, suppressEditSliderStep = _a.suppressEditSliderStep, theme = _a.theme;
        var maybeWrapWithROIStep = function (children) {
            return suppressEditSliderStep ? children : react_1.default.createElement(ROIStep_1.ROIStep, { id: UseHistoryTypes_1.ROIStepId.EditSlider }, children);
        };
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("roi-calculator-slider__container", theme), "data-interactive-zone": true },
            react_1.default.createElement(ROICalculatorSlider_1.ROICalculatorSlider, { label: this.props.label, max: this.props.max, min: this.props.min, increment: this.props.increment, value: this.props.value, onValueChange: this.handleValueChange }),
            react_1.default.createElement("div", { className: "roi-calculator__option-button--offset" }, maybeWrapWithROIStep(react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, position: kaleidoscope_1.PopoverPosition.Top, className: "roi-calculator-options", button: function (buttonProps) { return (react_1.default.createElement("div", { className: "roi-calculator-options__button" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Edit, null), "aria-label": "Edit" }, buttonProps, { tooltip: {
                            content: "Slider options",
                            show: roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.EditSlider) ? false : undefined,
                        }, onClick: function (ev) {
                            roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.EditSlider);
                            buttonProps.onClick(ev);
                        } })))); }, maxHeight: "calc(50vh - var(--control-size-medium) - var(--space-s))" }, this.renderInputOptions())))));
    };
    Object.defineProperty(ROISlider.prototype, "initialValueErrorMessage", {
        get: function () {
            var _a = this.props, min = _a.min, max = _a.max, initialValue = _a.initialValue;
            if (initialValue > max || initialValue < min) {
                return "".concat(initialValue, " is not in the range ").concat(min, "-").concat(max);
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROISlider.prototype, "minErrorMessage", {
        get: function () {
            var _a = this.props, min = _a.min, max = _a.max;
            if (min === max) {
                return "Min cannot equal max";
            }
            if (min > max) {
                return "Min must be smaller than max";
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROISlider.prototype, "maxErrorMessage", {
        get: function () {
            var _a = this.props, min = _a.min, max = _a.max;
            if (min === max) {
                return "Min cannot equal max";
            }
            if (min > max) {
                return "Max must be larger than min";
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROISlider.prototype, "incrementErrorMessage", {
        get: function () {
            var _a = this.props, max = _a.max, increment = _a.increment;
            if (increment < 0) {
                return "Increment cannot be negative";
            }
            if (increment === 0) {
                return "Increment cannot be 0";
            }
            if (increment > max) {
                return "".concat(increment, " is larger than max");
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROISlider.prototype, "highlightColor", {
        get: function () {
            var widgetStyles = this.props.blockStore.blockStyleStore.getElementStyle("roiCalculator");
            return widgetStyles.highlightColor;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROISlider.prototype, "initialValueErrorMessage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROISlider.prototype, "minErrorMessage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROISlider.prototype, "maxErrorMessage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROISlider.prototype, "incrementErrorMessage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROISlider.prototype, "highlightColor", null);
    ROISlider = __decorate([
        mobx_react_1.observer
    ], ROISlider);
    return ROISlider;
}(react_1.default.Component));
exports.default = ROISlider;
